import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import sliceNames from '../../constants/sliceNames';
import { SetClaimInfoLinkListAction } from '../index';

export interface ClaimSliceData {
    zipCode: string;
    claimNumber: string;
    errorMessage: boolean;
    selectedClaimInfoIndex: number | null;
    claimInfoLinkList: ClaimInfoLink[];
}

export interface UpdateClaimSliceData {
    zipCode?: string;
    claimNumber?: string;
    errorMessage?: boolean;
    selectedClaimInfoIndex?: number | null;
    claimInfoLinkList?: ClaimInfoLink[];
}

export const initialClaimSliceData: ClaimSliceData = {
    zipCode: '',
    claimNumber: '',
    errorMessage: false,
    selectedClaimInfoIndex: null,
    claimInfoLinkList: [],
};

const claimSlice = createSlice({
    name: sliceNames.claimSlice,
    initialState: initialClaimSliceData,
    reducers: {
        resetClaimData: () => initialClaimSliceData,
        setClaimNumber: (state: ClaimSliceData, action: PayloadAction<string>) => ({
            ...state,
            claimNumber: action.payload.replace(/\s/g, ''),
        }),
        setZipCode: (state: ClaimSliceData, action: PayloadAction<string>) => ({
            ...state,
            zipCode: action.payload.replace(/\s/g, ''),
        }),
        setClaimInfoLinkList: (state: ClaimSliceData, action: SetClaimInfoLinkListAction) => ({
            ...state,
            claimInfoLinkList: action.payload,
        }),
        clearClaimInfoLinkList: (state: ClaimSliceData) => ({
            ...state,
            claimInfoLinkList: [],
        }),
        setSelectedClaimInfoIndex: (state: ClaimSliceData, action: PayloadAction<number>) => ({
            ...state,
            selectedClaimInfoIndex: action.payload,
        }),
    },
});

const { actions, reducer } = claimSlice;
export const {
    resetClaimData,
    setClaimNumber,
    setZipCode,
    setClaimInfoLinkList,
    clearClaimInfoLinkList,
    setSelectedClaimInfoIndex,
} = actions;
export default reducer;
